import React, { useEffect, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import pencil from "../../../assets/Icons/pencil.svg";
import check from "../../../assets/Icons/tick.svg";
import cross from "../../../assets/Icons/wrong tick.svg";
import "react-dropdown/style.css";
import LocationService from "../../Services/LocationService";
import propertyService from "../../Services/PropertyService";
import { showErrorToast } from "../../Constant/Notification";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import Loader from "../../Constant/Loader";
import AsteriskStyle from "../../Form/Tooltip/AsteriskStyle";
const AddProperty = () => {
  // PropertyCreation
  const [propertyType, setPropertyType] = useState("");
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const [location, setLocation] = useState({});
  const [plots, setPlots] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [propertyPurchaseDate, setPropertyPurchaseDate] = useState(new Date());
  const [documentCharge, setDocumentCharge] = useState("");
  const [registrationCost, setRegistrationCost] = useState("");
  const [locationLink, setLocationLink] = useState("");
  const [surveyFee, setsurveyFee] = useState("");
 

  const [errors, setErrors] = useState({
    propertyType: "",
    name: "",
    location: "",
    plots: "",
    locationLink: "",
    surveyFee: "",
  });
  const [loading, setLoading] = useState(false);
  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await LocationService.fetchLocation();
        const data = response.data;
        const options = Object.entries(data).map(([key, value]) => ({
          label: key,
          value: value,
        }));
        setLocation(options);
      } catch (error) {
        showErrorToast(error.response.data);

        console.error("Error fetching locations:", error);
      }
    };

    fetchLocation();
  }, []);

  const handleChange = (e) => {
    setSelectedLocation(e.target.value);
    if (e.target.value) {
      setErrors({ ...errors, location: "" }); // Clear location error if a valid option is chosen
    } else {
      setErrors({ ...errors, location: "Location is required." });
    }
  };

  const handlePropertyPurchaseDate = (e) => {
    setPropertyPurchaseDate(e.target.value);
    if (e.target.value) {
      setErrors({ ...errors, propertyPurchaseDate: "" });
    } else {
      setErrors({
        ...errors,
        propertyPurchaseDate: "Property Purchase Date is required",
      });
    }
  };

  const handleNameChange = (e) => {
    setName(e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1));
    // Clear any previous error when the user changes the name
    setNameError("");
  };

  const validatePlot = () => {
    let isValidPlot = true;
    const newErrors = {
      plots: "",
    };
    if (inputList.length === 0) {
      newErrors.plots = "At least one plot is required.";
      isValidPlot = false;
    } else {
      // Check for empty plots
      if (inputList.some((plot) => plot.trim() === "")) {
        newErrors.plots = "Please fill in all plot details.";
        isValidPlot = false;
      }
    }
    setErrors(newErrors);
    return isValidPlot;
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      propertyType: "",
      name: "",
      location: "",
      propertyPurchaseDate: "",
    };

    if (!propertyType) {
      newErrors.propertyType = "Property type is required.";
      isValid = false;
    }
    if (!name) {
      newErrors.name = "Name is required.";
      isValid = false;
    }
    if (!selectedLocation) {
      newErrors.location = "Location is required.";
      isValid = false;
    }
    if (!propertyPurchaseDate) {
      newErrors.propertyPurchaseDate = "property Purchase Date is required.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    // Update inputList with calculated registrationCost
    const updatedInputList = inputList.map((plot) => ({
      ...plot,
      registrationCost:
        plot.guidlineSqftPrice && plot.sqftValue
          ? parseFloat(plot.guidlineSqftPrice) *
            parseFloat(plot.sqftValue) *
            0.09
          : 0,
    }));

    setInputList(updatedInputList); // Update state before submission

    // Validate and prepare plots data
    const plotsData = updatedInputList.map((plot, index) => {
      const indexValue = plot.indexValue ? String(plot.indexValue).trim() : "";
      const sqftValue = plot.sqftValue ? String(plot.sqftValue).trim() : "";
      const ratePerSqft = plot.ratePerSqft
        ? String(plot.ratePerSqft).trim()
        : "";
      const guidlineSqftPrice = plot.guidlineSqftPrice
        ? String(plot.guidlineSqftPrice).trim()
        : "";
      const registrationCost = plot.registrationCost || 0;

      if (!indexValue || !sqftValue || !ratePerSqft) {
        showErrorToast("Please fill in all plot details.");
        return null;
      }

      return {
        plotNo: indexValue,
        plotStatus: plot.plotStatus || "AVAILABLE",
        sqft: parseInt(sqftValue, 10),
        ratePerSqft: parseFloat(ratePerSqft),
        guidlineSqftPrice: parseInt(guidlineSqftPrice),
        order: index + 1,
      };
    });

    const validPlots = plotsData.filter((plot) => plot !== null);
    if (validPlots.length === 0) {
      showErrorToast("At least one valid plot is required.");
      return;
    }

    setLoading(true);

    // Prepare property data
    const propertyData = {
      type: propertyType,
      name: name,
      location: selectedLocation,
      locationLink: locationLink,
      surveyFee: Number(surveyFee),
      purchaseTime: propertyPurchaseDate,
      documentCharge: Number(documentCharge),
      plots: validPlots,
    };

    propertyService
      .createProperty(propertyData)
      .then(async (response) => {
        console.log("Property Added Successfully:", response.data);

        // Reset form fields
        setName("");
        setLocation("");
        setPropertyType("");
        setSelectedLocation("");
        setPropertyPurchaseDate("");
        setCount(0);
        setInputList([{ indexValue: "", sqftValue: "", ratePerSqft: "" }]);
       

        await new Promise((resolve) => setTimeout(resolve, 1000));

        if (userRole === "Admin") {
          navigate("/admin/property", {
            state: { message: "Property Created Successfully" },
          });
        } else if (userRole === "CMO") {
          navigate("/cmo/property", {
            state: { message: "Property Created Successfully" },
          });
        }
      })
      .catch((error) => {
        showErrorToast(error.response.data);
        console.error("There was an error adding the property:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [count, setCount] = useState(0);
  // const [inputList, setInputList] = useState([]);
  const [inputList, setInputList] = useState([
    {
      indexValue: "",
      sqftValue: "",
      ratePerSqft: "",
      guidlineSqftPrice: "",
      registrationCost: "",
      plotStatus: "AVAILABLE",
    },
  ]);

  const [editableIndex, setEditableIndex] = useState(null);
  const [tempValue, setTempValue] = useState("");

  const handleInputChange = (e, index, field) => {
    let { value } = e.target;
    if (field === "sqftValue") {
      value = value.replace(/[^0-9.]/g, ""); // Remove non-numeric and non-decimal characters
      const decimalCount = (value.match(/\./g) || []).length; // Count number of decimal points
      if (decimalCount > 1) {
        value = value.slice(0, value.lastIndexOf(".")); // Only allow one decimal point
      }
    } else if (field === "indexValue") {
      // Allow only alphanumeric characters
      value = value
        .replace(/[^a-zA-Z0-9]/g, "")
        .toUpperCase()
        .trim(); // Allow only alphanumeric, trim spaces, convert to uppercase

      // Check for duplicate Plot Number
      const isDuplicate = inputList.some(
        (item, idx) => idx !== index && item.indexValue === value
      );

      if (isDuplicate) {
        showErrorToast("Duplicate Plot Number is not allowed.");
        return; // Prevent updating state
      }
      // Remove non-alphanumeric characters
    } else if (field === "ratePerSqft") {
      value = value.replace(/[^0-9.]/g, ""); // Remove non-numeric and non-decimal characters
      const decimalCount = (value.match(/\./g) || []).length; // Count number of decimal points
      if (decimalCount > 1) {
        value = value.slice(0, value.lastIndexOf(".")); // Only allow one decimal point
      }
      if (value.includes(".")) {
        const [intPart, decimalPart] = value.split(".");
        value = intPart + "." + decimalPart.slice(0, 2); // Keep only 2 digits after decimal
      }
    } else if (field === "guidlineSqftPrice") {
      value = value.replace(/[^0-9.]/g, ""); // Remove non-numeric and non-decimal characters
      const decimalCount = (value.match(/\./g) || []).length; // Count number of decimal points
      if (decimalCount > 1) {
        value = value.slice(0, value.lastIndexOf(".")); // Only allow one decimal point
      }
    } else if (field === "registrationCost") {
      value = value.replace(/[^0-9.]/g, ""); // Remove non-numeric
    } else if (field === "plotStatus") {
      // Handle plot status change if needed
      // value = value.replace(/[^a-zA-Z]/g, ""); // Allow only alphabetic characters
      value = value.trim(); // Trim spaces
    
    }

    // Make a shallow copy of the inputList
    const newInputList = [...inputList];

    // Ensure the item at index is an object before trying to assign properties
    if (typeof newInputList[index] !== "object") {
      newInputList[index] = { indexValue: "", sqftValue: "", ratePerSqft: "" }; // Initialize it as an object if it's not already
    }

    // Set the field value dynamically (field can be 'indexValue' or 'sqftValue')
    newInputList[index][field] = value;

    // Update the state with the new array
    setInputList(newInputList);
  };

  const handleEditClick = (index) => {
    setTempValue(inputList[index]);
    setEditableIndex(index);
  };

  const handleSaveClick = () => {
    if (
      typeof inputList[editableIndex].indexValue === "string" &&
      typeof inputList[editableIndex].sqftValue === "string" &&
      inputList[editableIndex].indexValue.trim() !== "" &&
      inputList[editableIndex].sqftValue.trim() !== ""
    ) {
      const newInputList = [...inputList];

      // Trim whitespace for both index and square feet values
      newInputList[editableIndex].indexValue =
        newInputList[editableIndex].indexValue.trim();
      newInputList[editableIndex].sqftValue =
        newInputList[editableIndex].sqftValue.trim();

      setInputList(newInputList);
      setEditableIndex(null);
      setTempValue(""); // Clear the temp value after saving
    } else {
      console.error("Either indexValue or sqftValue is invalid or empty.");
    }
  };

  const handleCancelClick = (index) => {
    const newInputList = [...inputList];

    // Revert to the original value if editing is canceled
    newInputList[index] = tempValue;
    setInputList(newInputList);

    setEditableIndex(null);
    setTempValue(""); // Clear the temp value after canceling
  };
  const navigate = useNavigate();
  const handleBack = () => {
    if (userRole === "Admin") {
      navigate("/admin/property");
    } else if (userRole === "CMO") {
      navigate("/cmo/property");
    }
  };

  const handleDocumentChargeChange = (value) => {
    setDocumentCharge(value);
  };

  return (
    <div className="bg-appGrayBackground pb-10 3xl:h-screen">
      {loading ? <Loader /> : ""}
      <AdminAppBar />
      <ToastContainer />
      <div className="mt-20 pt-4 px-6">
        <div className="flex justify-between">
          <div className="flex gap-6">
            <svg
              onClick={handleBack}
              className=" cursor-pointer"
              width="20"
              height="34"
              viewBox="0 0 22 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
                fill="#399E79"
              />
            </svg>
            <div className="font-semibold md:mx-0 3xl:ml-12 lg:mx-0 md:text-2xl lg:text-4xl">
              Add New Property
            </div>
          </div>

          <div className="">
            <button
              onClick={handleSubmit}
              className={`${loading ? "bg-slate-300" : "bg-customGreen"} text-white md:w-28  md:h-9 lg:w-48 lg:h-11 rounded-md md:text-xl
          lg:text-2xl font-medium`}
              disabled={loading}
            >
              Create Property
            </button>
          </div>
        </div>

        <form className="bg-white shadow-md rounded 3xl:w-12/12 3xl:h-[800px] 3xl:ml-12 md:px- 4 lg:px-8 md:px-4 lg:pt-7 md:pt-6 md:pb-4 lg:pb-8 md:mt-8 lg:mt-8 md:mx-0 lg:mx-0 md:mb-4 lg:w-full md:w-full">
          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium"
              htmlFor=""
            >
              Property Type <AsteriskStyle/>
            </label>
            <div className="flex w-3/4 relative">
              <select
                className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.propertyType ? "border-red-500" : ""
                }`}
                // className="appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="lead-source"
                name="lead-source"
                required
                value={propertyType}
                onChange={(e) => setPropertyType(e.target.value)}
                onFocus={() => setErrors({ ...errors, propertyType: "" })}
              >
                <option value="">Select property type</option>
                <option value="Layout">Layout</option>
                <option value="Villa">Villa</option>
                <option value="Apartment">Apartment</option>
                <option value="Resale Land">Resale Land</option>
                <option value="Resale Building">Resale Building</option>
                <option value="Acres and Cents">Acres and Cents</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  width="18"
                  height="12"
                  viewBox="0 0 24 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
                    fill="#399E79"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium "
              htmlFor="name"
            >
              Name <AsteriskStyle/>
            </label>
            <input
              className={`shadow appearance-none border rounded w-3/4 py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.name ? "border-red-500" : ""
              }`}
              id="name"
              type="text"
              
              placeholder={errors.name || "Enter Property Name"}
              required
              value={name}
              maxLength={50}
              onFocus={() => setErrors({ ...errors, name: "" })}
              onChange={handleNameChange}
              // onChange={(e) => setName(e.target.value.charAt(0).toUpperCase()+ e.target.value.slice(1))}
            />
          </div>
          <div className="mb-8 flex items-center ">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium"
              htmlFor="lead-source"
            >
              Location <AsteriskStyle/>
            </label>

            <div className="flex w-1/4 relative">
              <select
                id="location"
                value={selectedLocation}
                onChange={handleChange}
                onFocus={() => setErrors({ ...errors, location: "" })}
                className={`w-full  px-3 py-2 border border-gray-300 text-gray-700 leading-tight focus:outline-none focus:shadow-outline rounded-md ${
                  errors.location ? "border-red-500" : ""
                }`}
              >
                <option value="">Select a location</option>
                {Array.isArray(location) &&
                  location.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium "
              // htmlFor="name"
            >
              Location Link 
            </label>
            <input
              className={`shadow appearance-none border rounded w-1/4 py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline `}
              id="location-link"
              type="text"
              placeholder={errors.locationLink || ""}
              onChange={(e) => setLocationLink(e.target.value)}
            />
          </div>

          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-gray-700 text-2xl font-medium">
              Survey Fee
            </label>
            <input
              className={`shadow appearance-none border rounded w-1/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.surveyFee ? "border-red-500" : ""
              }`}
              id="survey-number"
              type="text"
              maxLength={10}
              
              placeholder={errors.surveyFee || ""}
              required
              value={surveyFee}
              onChange={(e) => {
                let val = e.target.value.replace(/[^0-9.]/g, '');
                if (val.includes('.')) {
                  const [intPart, decPart] = val.split('.');
                  val = intPart + '.' + decPart.slice(0, 2);
                }
                setsurveyFee(val);
              }}
              
            />
          </div>

          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium "
              // htmlFor="name"
            >
              Property Purchase Date <AsteriskStyle/>
            </label>
            <input
              className={`shadow appearance-none border rounded w-1/4 py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.name ? "border-red-500" : ""
              }`}
              id="Property Purchase Date"
              type="date"
              placeholder={errors.propertyPurchaseDate || ""}
              required
              value={propertyPurchaseDate}
              onFocus={() => setErrors({ ...errors, propertyPurchaseDate: "" })}
              onChange={handlePropertyPurchaseDate}
            />
          </div>

          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium "
              // htmlFor="name"
            >
              Document Charge 
            </label>
            <input
              className={`shadow appearance-none border rounded w-1/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.documentCharge ? "border-red-500" : ""
              }`}
              id="Document Charge"
              type="text"
              maxLength={10}
              placeholder={errors.documentCharge || ""}
              required
              value={documentCharge}
              onChange={(e) => {
                let val = e.target.value.replace(/[^0-9.]/g, '');
                if (val.includes('.')) {
                  const [intPart, decPart] = val.split('.');
                  val = intPart + '.' + decPart.slice(0, 2);
                }
                handleDocumentChargeChange(val);
              }}
              
            />
          </div>

          <div className="mb-8 w-full flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium"
              htmlFor="name"
            >
              Total of Plots
            </label>
            <div className="flex items-center ">
              <input
                type="text"
                className={`shadow appearance-none border rounded w-4/4 py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline `}
                value={count}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only positive numbers or an empty string
                  if (/^\d*$/.test(value)) {
                    const numericValue = Number(value);
                    if (value === "" || (numericValue >= 1 && numericValue <= 500)) {
                      setCount(value);
                    }
                  }
                }}
              />
            </div>
          </div>

          <div className="">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Plot
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Square Feet
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Approx Rate Per Sqft
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Approx Total Price
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Guidline Sqft Price
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Registration Charge
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {Array.from({ length: count }).map((_, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="text"
                        value={inputList[index]?.indexValue || ""}
                        className={`border border-gray-300 px-2 py-1 w-full rounded focus:outline-none  ${
                          editableIndex === index
                            ? ""
                            : "pointer-events-none bg-gray-100"
                        }`}
                        maxLength={10}
                        onChange={(e) =>
                          handleInputChange(e, index, "indexValue")
                        }
                        placeholder="Plot No"
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="text"
                        value={inputList[index]?.sqftValue || ""}
                        onChange={(e) =>
                          handleInputChange(e, index, "sqftValue")
                        }
                        className={`border border-gray-300 px-2 py-1 w-full rounded focus:outline-none  ${
                          editableIndex === index
                            ? ""
                            : "pointer-events-none bg-gray-100"
                        }`}
                        placeholder="Sqft value"
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="text"
                        value={inputList[index]?.ratePerSqft || ""}
                        maxLength={10}
                        onChange={(e) =>
                          handleInputChange(e, index, "ratePerSqft")
                        }
                        className={`border border-gray-300 px-2 py-1 w-full rounded focus:outline-none  ${
                          editableIndex === index
                            ? ""
                            : "pointer-events-none bg-gray-100"
                        }`}
                        placeholder="Approx Rate Per Sqft"
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="text"
                        value={
                          Number(inputList[index]?.ratePerSqft *
                            inputList[index]?.sqftValue).toFixed(2) || ""
                        }
                        onChange={(e) =>
                          handleInputChange(e, index, "ratePerSqft")
                        }
                        className={`border border-gray-300 bg-gray-100 cursor-default px-2 py-1 w-full rounded focus:outline-none  ${
                          editableIndex === index
                            ? ""
                            : "pointer-events-none bg-gray-100"
                        }`}
                        placeholder="Approx Total Price"
                        readOnly
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="text"
                        value={inputList[index]?.guidlineSqftPrice || ""}
                        onChange={(e) =>
                          handleInputChange(e, index, "guidlineSqftPrice")
                        }
                        className={`border border-gray-300   px-2 py-1 w-full rounded focus:outline-none  ${
                          editableIndex === index
                            ? ""
                            : "pointer-events-none bg-gray-100"
                        }`}
                        placeholder="Guidline Sqft Price"
                      />
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="number"
                        value={
                          inputList[index]?.guidlineSqftPrice *
                            inputList[index]?.sqftValue *
                            0.09 || ""
                        }
                        className="border border-gray-300 px-2 py-1 w-full rounded focus:outline-none"
                        onChange={(e) =>
                          handleInputChange(e, index, "registrationCost")
                        }
                        placeholder="Enter Registration Cost"
                      />
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <select
                        value={inputList[index]?.plotStatus}
                        onChange={(e) =>
                          handleInputChange(e, index, "plotStatus")
                        }
                        className={`border border-gray-300 px-2 py-1 w-full rounded focus:outline-none  ${
                          editableIndex === index
                            ? ""
                            : "pointer-events-none bg-gray-100"
                        }`}
                        placeholder="Status"
                      >
                        <option value="AVAILABLE">Available</option>
                        <option value="REGISTERED">Registered</option>
                        <option value="BOOKED">Booked</option>
                        <option value="AGREEMENT">Agreement</option>
                      </select>
                    </td>
                    <td className="items-center justify-center pt-6 flex gap-5 whitespace-nowrap">
                      {editableIndex === index ? (
                        <>
                          <img
                            src={check}
                            alt="Save"
                            className="w-4 h-4 cursor-pointer"
                            onClick={handleSaveClick}
                          />
                          <img
                            src={cross}
                            alt="Cancel"
                            className="w-4 h-4 cursor-pointer"
                            onClick={() => handleCancelClick(index)}
                          />
                        </>
                      ) : (
                        <>
                          <img
                            src={pencil}
                            alt="Edit"
                            className="w-4 h-4 cursor-pointer"
                            onClick={() => handleEditClick(index)}
                          />
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddProperty;
